export const GET_DOMAINS = 'GET_DOMAINS'
export const GET_ROOMS = 'GET_ROOMS'
export const GET_ADVICES = 'GET_ADVICES'
export const SET_DOMAINS = 'SET_DOMAINS'
export const SET_ROOMS = 'SET_ROOMS'
export const SET_ADVICES = 'SET_ADVICES'
export const GET_DOMAINS_ERROR = 'GET_DOMAINS_ERROR'
export const GET_ROOMS_ERROR = 'GET_ROOMS_ERROR'
export const GET_ADVICES_ERROR = 'GET_ADVICES_ERROR'
export const RESET_DOMAINS = 'RESET_DOMAINS'
export const RESET_ROOMS = 'RESET_ROOMS'
export const RESET_ADVICES = 'RESET_ADVICES'
export const SET_ADVICE_ID = 'SET_ADVICE_ID'
export const SET_ADVICE_FILTERS = 'SET_ADVICE_FILTERS'
export const RESET_ADVICE_FILTERS = 'RESET_ADVICE_FILTERS'
export const SET_DOMAIN_ROOMS_SELECTION = 'SET_DOMAIN_ROOMS_SELECTION'
